let card = [
  {
    image: "/assets/images/frontend-guide.png",
    description: "NextJS, TailwindCSS",
    title: "frontend-guide",
    link: "https://frontend-guide.vercel.app/",
  },
  {
    image: "/assets/images/IMDB-Clone.png",
    description: "ReactJS, TailwindCSS",
    title: "IMDB-Clone",
    link: "https://what-da-review.vercel.app",
  },
  {
    image: "/assets/images/maps.png",
    description: "SvelteJS, TailwindCSS, Google Maps",
    title: "Maps custom marker",
    link: "https://stackblitz.com/edit/node-ye2bpa?file=src%2Fpages%2FcurrentLocation.svelte",
  },

  {
    image: "/assets/images/Analyst-page.png",
    description: "ReactJS, SCSS, Axios, API",
    title: "Data Dashboard",
    link: "https://codesandbox.io/s/greedygame-analytics-assignment-8ksc0",
  },
];

module.exports = { card };
